import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";

export const ActiveContainer = styled.div`
    grid-column: 1 / span 4;
    background:#197B85;
    padding:10px 20px;
    height:48px;
    border-radius:8px;
    position: relative;
    overflow:hidden;
    cursor: pointer;

    span{
        color:#fff;
        font-size: 16px;
        font-weight: 500;
    }

    p{
        color:#fff;
    }

    
    ${mq(Devices.tablet)}{
        grid-column: 1 / span 2;
    }

    ${mq(Devices.mobile)}{
        grid-column: 1 / span 1;
    }
`;

export const BgOverlay = styled.div`
    position: absolute;
    right:16px;
    top:-30%;
    height:100%;
    opacity: 0.3;

    svg{
        height:180%;

        path{
            fill:#fff;
        }
    }
`;

